/**
 * Before the calculator lets go of what the person answered — closing it, or
 * starting again — it asks. "Keep answering" is the safe choice, and the one
 * a stray Escape or click lands on.
 */
import { AlertTriangle } from '@tonnie/assets';
import { useLocale } from '@tonnie/locale';
import { ConfirmDialog } from '@tonnie/ui';

export type CalculatorDiscard = 'close' | 'restart';

export function CalculatorDiscardDialog({
  asking,
  onKeep,
  onDiscard,
}: {
  /** What would be let go of — or null while nothing is asked. */
  asking: CalculatorDiscard | null;
  onKeep: () => void;
  onDiscard: () => void;
}) {
  const { t } = useLocale();
  const restart = asking === 'restart';
  return (
    // The answers are lost, but nothing is kept anywhere yet: caution, not danger (D5).
    <ConfirmDialog
      open={asking !== null}
      onOpenChange={(open) => (open ? undefined : onKeep())}
      intent="caution"
      icon={AlertTriangle}
      title={
        restart ? t('inout.calculator.discard.restartTitle') : t('inout.calculator.discard.title')
      }
      description={
        restart ? t('inout.calculator.discard.restartBody') : t('inout.calculator.discard.body')
      }
      cancelLabel={t('inout.calculator.discard.keep')}
      confirmLabel={
        restart ? t('inout.calculator.result.restart') : t('inout.calculator.discard.confirm')
      }
      onConfirm={onDiscard}
      data-testid="inout-calculator-discard"
      cancelTestId="inout-calculator-discard-keep"
      confirmTestId="inout-calculator-discard-confirm"
    />
  );
}
